import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type addRDTPayload, type ProjectState } from "../../types/projects";
import type { RootState } from "../store";

const initialState: ProjectState = {
  projectData: {
    uid: "",
    projectName: "",
  },
  selectedTestIds: [],
  newTestFormValues: undefined,
};

const projectSlice = createSlice({
  name: "project",
  initialState,
  reducers: {
    setProjectName: (state, action: PayloadAction<string>) => {
      state.projectData = { ...state.projectData, projectName: action.payload };
    },
    persistSelectedTestIds: (state, action: PayloadAction<string[]>) => {
      state.selectedTestIds = action.payload;
    },
    setNewTestFormValues: (state, action: PayloadAction<addRDTPayload>) => {
      state.newTestFormValues = action.payload;
    },
    clearProject: () => initialState,
    clearNewTestFormValues: state => {
      state.newTestFormValues = undefined;
    },
    clearSelectedTestIds: state => {
      state.selectedTestIds = [];
    },
  },
});

export const {
  setProjectName,
  persistSelectedTestIds,
  setNewTestFormValues,
  clearProject,
  clearNewTestFormValues,
  clearSelectedTestIds,
} = projectSlice.actions;
export const selectProjectName = (state: RootState) => state.project.projectData?.projectName;
export const getSelectedTestIds = (state: RootState) => state.project.selectedTestIds;
export const getNewTestFormValues = (state: RootState) => state.project.newTestFormValues;
export default projectSlice.reducer;
